import React from 'react';
import SEO from '@/SEO';

const HTML_CONTENT = `<h1>ஸந்தியா வந்தனம்</h1>
  <div class="head2"> போதாயனம் ஆபஸ்தம்பம் இருவருக்கும் காலை, மதியம், மாலை 3 வேளைக்கும் பொதுவானது</div>
  
  <div class="head2">அர்க்ய விதி (வெளியே)</div>
  <mat-accordion>
    <mat-expansion-panel>
      <mat-expansion-panel-header>பொதுக் குறிப்புகள்</mat-expansion-panel-header>
    <div class="div3">
      <span class="title3">குறிப்பு 1:-</span> ஸ்நானம் செய்தபின் ஸந்த்யாவந்தனம் செய்யவேண்டும். <Br>
        ஸ்நானம் செய்ய இயலவில்லை என ஸந்த்யாவந்தனத்தைக் கைவிடவோ, தள்ளிப்போடவோ வேண்டாம். 
        “தான் தயாராதல்” எனும் தலைப்பில் - ஸ்நானம் என்கிற உப தலைப்பின் இறுதியில் 
        7 வகைச் ஸ்நானங்கள் செய்யும் முறை வழங்கப்பட்டுள்ளது. அவற்றில் ஒன்றை செய்து 
        ஸந்த்யா வந்தனத்தைக் காலத்தில் செய்யவும். <Br>
        <span class="title3">குறிப்பு 2:-</span>
        ஸந்தியாவந்தனம் காலையில் கிழக்கு முகமாக நின்று கொண்டும்<br>
    மதியத்தில் கிழக்கு அல்லது வடக்கு முகமாக நின்று கொண்டும் <br>
    மாலையில் மேற்கு முகமாக அமர்ந்து கொண்டும் செய்யவேண்டும். <br> 
    ஆசமனத்தை எப்போதும் குக்குடாஸனத்தில் குந்தி உட்கார்ந்துகொண்டு - 
    கிழக்கு அல்லது வடக்கு முகமகாகவும், ப்ராணாயாமம் மற்றும் ஸங்கல்பம் வரை 
    கிழக்கு முகமாக தரையில் அமர்ந்து கொண்டும் செய்துகொள்ளவேண்டும். </div>
    </mat-expansion-panel> 
    <mat-expansion-panel>
        <mat-expansion-panel-header>01-ஆசமனம்</mat-expansion-panel-header>
        <div class="div3">
          <div class="hint">ஆசமனம், ப்ராணாயாமம் அடிக்கடி செய்யவேண்டியிருக்கும், எனவே, இதை நன்றாகத் தெரிந்து வைத்துக்கொண்டு கர்மாவைச் செய்தால்
            விரைவாகவும், சிறப்பாகவும் செய்யலாம்.
          </div>         
            <img src="assets/img/achamanam.gif">
          <h3>Achamanam - Audio </h3>
          <audio controls>
            <source src="http://www.brahminsnet.com/upakarma/audio/achamanam.ogg" type="audio/ogg">
              <source src="http://www.brahminsnet.com/upakarma/audio/mp4/achamanam.mp4" type="audio/mp4">
             Your browser does not support the audio element.
          </audio>
          <div class="hint">ஒரு நாளில், ஒரு கர்மாவின் ஆரம்பத்திலும், முடிவிலும் இரண்டு முறை ஆசமனம் செய்யவேண்டும். இடையிடையே ஒவ்வொரு முறை
            செய்தால் போறும்.
          </div>
          <div class="sans">
            ओं अच्युताय नम:।
            ओं अनन्ताय नम:।
            ओं गोविन्दााय नम:।
            <table>
              <tr>
                <td class="sans">ओं केशवाय नम:। </td>
                <td class="sans">नारायणाय नम:।</td>
              </tr>
              <tr>
                <td class="sans">माधवाय नम:।</td>
                <td class="sans">गोविन्दाय नम:।</td>
              </tr>
              <tr>
                <td class="sans">विष्णवे नम:। </td>
                <td class="sans">मधुसूदनाय नम:।
                </td>
              </tr>
              <tr>
                <td class="sans"> त्रिविक्रमाय नम:। </td>
                <td class="sans">वामनाय नम:।
                </td>
              </tr>
              <tr>
                <td class="sans">श्रीधराय नम:। </td>
                <td class="sans">हृषीकेशाय नम:।
                </td>
              </tr>
              <tr>
                <td class="sans">पद्मनाभाय नम:। </td>
                <td class="sans">दामोदराय नम:।</td>
              </tr>
            </table>
          </div></div> 
           </mat-expansion-panel>
      <mat-expansion-panel>
        <mat-expansion-panel-header>02-ப்ராணாயாமம்</mat-expansion-panel-header>
        <div class="div3">
<ion-row><ion-col size="2">
  <img src="assets/img/Praanaayaamam3.jpg" class="img2">
</ion-col><ion-col size="10">
  வலது மூக்குத் துவாரத்தை, வலது கட்டை விரலால் அழுத்தி அடைக்கவும்.
</ion-col></ion-row> 
  <img src="assets/img/Praanaayaamam4.jpg" class="img2">
  <div class="hint"> வாயை நன்கு மூடி, சுட்டு விரல், நடு விரல்களை உள்ளே மடித்து, இட மூக்குத் துவாரம் வழியாக, வெளிக்காற்றை, முடிந்தவரை
    உள்ளிழுத்து நிறுத்தி, மோதிர, சுண்டு விரல்களால், இடமூக்குத் துவாரத்தையும் நன்கு அடைத்து ப்ராணாயாம மந்திரத்தை
    3 முறை சொல்லவும்.
  </div>
          <div class="sans">
            ஓம் பூ: ஓம் புவ: ஓகும்ஸுவ: ஓம் மஹ: ஓம் ஜன: ஓம் தப: ஓம் ஸத்யம், ஓம் தத்ஸவிதுர்வரேண்யம் பர்கோதேவஸ்யதீமஹி தியோயோந:ப்ரசோதயாத்
            ஓமாப: ஜ்யோதீரஸ: அம்ருதம் ப்ரஹ்மா பூர்புவஸ்ஸுவரோம்.
          </div>
          <h3>ப்ராணாயாமம்</h3>
          <div class="sans">
            ओं भू:। ओं भुव:। ओँसुव:। ओं मह:। ओं जन:। ओं तप:। ओँसत्यम्। ओं तत्सवितुर्वरेण्यं भर्गो देवस्य धीमहि । धियो यो न: प्रचोदयात्।
            ओमापो ज्योती रसोऽमूतं ब्रह्म भूर्भुवस्वरोम्।।
          </div>           
            <img src="assets/img/praanaayaamam.gif"></div>
      </mat-expansion-panel>
      <mat-expansion-panel>
        <mat-expansion-panel-header>03-ஸங்கல்பம்</mat-expansion-panel-header>
     <div class="div3">
      <table>
        <tr>
          <td><img src="assets/svg/vkThiruman.svg" class="svgs" >
            ஸ்ரீபகவதாஜ்ஞயா ஸ்ரீமந்நாராயண ப்ரீத்யர்த்தம்</td>
          <td>
            <img src="assets/svg/tkThiruman.svg" class="svgs">
            ஸ்ரீபகவதாஜ்ஞயா பகவத் கைங்கர்ய ரூபம்</td>
        </tr>
      </table>  
      <mat-tab-group  mat-stretch-tabs >
        <mat-tab label="காலை">
          ப்ராதஸ் ஸந்த்யாம் உபாசிஷ்யே|    <br>
            प्रातस् सन्ध्याम् उपास्ष्येि ।
        </mat-tab>
        <mat-tab label="மதியம்">
          மாத்யாஹ்நிக ஸந்த்யாம் உபாசிஷ்யே<br>
          मात्याह्निग सन्ध्याम् उपास्ष्येि ।
        </mat-tab>
        <mat-tab label="மாலை">
          ஸாயம் ஸந்த்யாம் உபாசிஷ்யே<br>
          सायम्सन्ध्याम् उपास्ष्येि ।
        </mat-tab>
      </mat-tab-group>    
          </div>
          <div class="mydiv">
            <img src="assets/svg/vkThiruman.svg" class="svgs" >
            <div class="sans">
              பகவாநேவ ஸ்வசேஷபூதமிதம் ப்ராதஸ் (/ மாத்யாஹ்நிக / ஸாயம்) ஸந்த்யாவந்தனாக்யம் கர்ம ஸ்வஸ்மை ஸ்வப்ரீதயே பகவான் ஸ்வயமேவ காரயதி|
            </div>
            <div class="sans">
              भगवानेव स्वशेष भूतमितं प्रातस् / मात्याह्निग / सायं सन्ध्यावन्दनाख्यं कर्म स्वस्मै स्वप्रीतये भगवान् स्वयमेव कारयति।
                   </div>
      </div>
      </mat-expansion-panel>
      <mat-expansion-panel>
        <mat-expansion-panel-header>04-ப்ரோக்ஷணம் </mat-expansion-panel-header>
        <div class="div3">
        <div class="hint">போதாயன சூத்ரக்காரர்கள் மட்டும் 3 வேளை ஸந்தியிலும் ப்ரோக்ஷண மந்த்ரத்திற்கு முன்னதாக - ஜலாபிமந்த்ரண மந்த்ரம் என்கிற
          ஒரு சிறு பகுதியை சேர்த்து அநுஷ்டிக்க வேண்டும். (அநுக்தம் அந்யதோ க்ராஹ்யம் என்கிற விதியினால் - நன்மை தரும் நல்ல
          விஷயத்தை அடுத்த சூத்திரத்திலிருந்தும் எடுத்துப் பயன்படுத்தலாம் என்பதாலும், போதாயன அநுஷ்டானம் மற்ற எல்லா சூத்திரக்காரர்களுக்கும்
          அநுஷ்டிக்கத் தக்கது என்பதாலும் இதை யாவரும் பயன்படுத்தினால் ச்ரேஷ்டமே!)
          <br> பாத்திரத்தில் உள்ள ஜலத்தைத் வலது கையால் தொட்டுக்கொண்டு கீழ்வரும் மந்திரத்தைச் சொல்லவும்</div>
      <span class="sans">  ஆபாவோ இதகும்ஸர்வம்
        விஸ்வாபூதாந்யாப:
        ப்ராணா வா ஆப:
        பசவ ஆப: அம்ருதமாப:
        அந்நமாப:
        ஸம்ராடாப:
        விராடாப:
        ஸ்வராடாப:
        சந்தாகும்ஸி ஆப:
        ஜ்யோதீகும்ஷி ஆப:
        ஸத்யமாப:
        ஸர்வாதேவதா ஆப:
        பூர்புவஸ்ஸுவராப ஓம் || </span>        
        <div class="hint">
          என்று ஜபித்து அந்த ஜலத்திலிருந்து ஓம் கேசவாய நம: என்று அந்த ஜலத்தினால் ஊர்த்வ புண்ட்ரம் தரிக்கவேண்டும்.</div>
        <div class="sans">
          आपो वा इदँसर्वं विश्वाभूतान्याप:। प्र्राणा वा आप:। पशव आप:। अमृतम् आप:। अन्नमाप:। संराडाप:। विराडाप:। स्वराडाप:। छन्दाँसि
          आप:। ज्योतीँषि आप:। सत्यमाप:। सर्वा देवता आप:। भूर्भुवस्सुवराप ओं।।
        </div>
      
  <table>
<tr><td style="width: 20%;">
  <img src="assets/img/Nyaasam1.jpg" class="img2">
</td><td style="width: 80%;">
  <span class="hint"> தலையைத் தொட்டு :</span>
  <span class="sans"> ஆபோஹிஷ்டா இதி மந்த்ரஸ்ய சிந்துத்வீப ருஷி:&nbsp;&nbsp;
    आपोहिष्ठा इति मन्त्रस्य सिन्धुद्वीप ऋषि:</span>
</td></tr> 

  <tr><td style="width: 20%;">
  <img src="assets/img/Nyaasam2.jpg" class="img2">
</td><td style="width: 80%;">
  <span class="hint">மூக்கைத் தொட்டு :-</span>
 
  <span class="sans">அநுஷ்டுப் சந்த:&nbsp;&nbsp; अनुष्टुप् छन्द:</span>
</td></tr> 

 <tr><td style="width: 20%;">
  <img src="assets/img/Nyaasam3.jpg" class="img2">
</td><td style="width: 80%;">
 
  <span class="sans">ஆபோ தேவதா &nbsp;&nbsp;आपो देवता </span>
</td></tr> 

  <tr><td style="width: 20%;">
  <img src="assets/img/Nyaasam4.jpg" class="img2">
</td><td style="width: 80%;">
 
  <span class="sans">அபாம் ப்ரோக்ஷணே விநியோக:&nbsp;&nbsp;
    अपाम् प्रोक्षणे विनियोग:।</span>
</td></tr>            
</table>           
          <div class="hint"> எனக்கூறி
            <br>4 விரல்களின் நுனிகளால் ஒவ்வொரு மந்திரத்திற்கும்
            தலையில் தீர்த்தம் ப்ரோக்ஷித்துக்கொள்ளவும்
            “ச்ச” - என காணப்பட்டால் ஒழிய “ச” வரும் இடங்களில்
            “சங்கர்” - என்பதில் வரும் ச போலவே ஒலிக்கவும்.
          </div>
          <div class="sans">
            ஓம் பூர்புவஸ்ஸுவ: தத்ஸவிதுர்வரேண்யம் பர்கோ தேவஸ்ய தீமஹி தியோயோந: ப்ரசோதயாத் (3 தரம்)
            <br> ஆபோஹிஷ்டா மயோபுவ:
            <br>தானஊர்ஜே ததாநா
            <br>மஹேரணாய க்ஷக்சஸே
            <br>யோவஸ்சிவதமோ ரஸ:
            <br>தஸ்யபாஜயதேஹந:
            <br>உசதீரிவ மாதர:
            <br> தஸ்மா அரங்கமாமவ:</div>
          <span class="hint">அடுத்த மந்திரத்திற்கு மட்டும் முழங்கால்களில் ப்ரோக்ஷணம்</span>
          <span class="sans">யஸ்யக்ஷயாய ஜிந்வதா</span>
          <span class="hint">பின் மீண்டும் தலையில்</span>
          <span class="sans"> ஆபோஜநயதாஜந:</span>
          <span class="hint">தலையைச்சுற்றி</span>
          <span class="sans">ஓம் பூர்புவஸ்சுவ:” </span>
          <span class="hint">என்று தீர்த்தம் விடறது.</span>
          <div class="sans">
            ओं भूर्भुवस्सुव: ।
            <br> तत्सवितुर्वरेण्यं भर्गो देवस्य धीमहि धीयो यो न: प्रचोदयात्। (3 tims)
            <br> ओं आपोहिष्ठा मयोॅाुव:।
            <br> ता न उूर्जे दधातन।
            <br> महेरणाय चक्षसे।
            <br> योव: शिवतमो रस:।
            <br> तस्य भाजयतेहन:।
            <br> उशतीरिव मातर:।
            <br> तस्मा अरङ्गमामव:।
            <br> यस्यक्षयाय जिन्वथ।
            <br> आपो जनयथा च न:।
            <br> ओं भूर्भुवस्सुव:।
            <br>
          </div></div>
      </mat-expansion-panel>
      <mat-expansion-panel>
        <mat-expansion-panel-header>05-ப்ராசனம் </mat-expansion-panel-header>
        <div class="div3">
            <table>
<tr><td style="width: 20%;">
  <img src="assets/img/Nyaasam1.jpg" class="img2">
</td><td style="width: 80%;">
  <span class="hint"> தலையைத் தொட்டு :</span>
 
           <span class="sans"> ஸூர்யஸ்ச இதி அநுவாகஸ்ய அக்நி ருஷி:&nbsp;&nbsp;
            सूर्यश्च इति अनुवाकस्य अग्नि ऋषि:</span>
          </td></tr> 
     
            <tr><td style="width: 20%;">
  <img src="assets/img/Nyaasam2.jpg" class="img2">
</td><td style="width: 80%;">
  <span class="hint">மூக்கைத் தொட்டு :-</span>
  
            <span class="sans">காயத்ரீ சந்த:&nbsp;&nbsp; गायत्री छन्द:</span>
          </td></tr> 
          
         
           <tr><td style="width: 20%;">
  <img src="assets/img/Nyaasam3.jpg" class="img2">
</td><td style="width: 80%;">
  <span class="hint">மார்பைத் தொட்டு :-</span>
  
            <span class="sans">ஸூர்யோ தேவதா &nbsp;&nbsp;सूर्यो देवता </span>
          </td></tr> 
          
        
            <tr><td style="width: 20%;">
  <img src="assets/img/Nyaasam4.jpg" class="img2">
</td><td style="width: 80%;">
  <span class="hint">இரு கைகளையும் உட்புறமாகத் திருப்பி:</span>
  
            <span class="sans">அபாம் ப்ராசநே விநியோக:&nbsp;&nbsp;
              अपाम् प्राशने विनियोग:।</span>
          </td></tr>            
          </table> 
              <table>
              <tr><td >
                <img src="assets/img/AachamanamStep1.jpg" class="img2">
                     
            <span class="hint">என ந்யாஸம் செய்து,
              வலது உள்ளங்கையைக் குழித்து நீரை நிரப்பி கீழ் - மந்திரம் முடிந்ததும் அருந்தவும்</span>
            <span class="sans">
              “ஸூர்யச்ச மாமந்யுச்ச மந்யுபதயச்ச மந்யுக்ருதேப்ய:,
              பாபேப்யோ ரக்ஷந்தாம், யத் ராத்ரியா பாபம் அகார்ஷம்,
              மநஸா வாசா ஹஸ்தாப்யாம்,
              பத்ப்யாம் உதரேண சிச்ஞ்நா, ராத்ரிஸ்தத் அவலும்பது,
              யத்கிஞ்ச துரிதம் மயி, இதமஹம் மாம் அம்ருதயோநௌ,
               ஸூர்யே ஜ்யோதிஷி
              ஜுஹோமி ஸ்வாஹா”
            </span>
            <div class="sans">
              सूर्यश्च मामन्युश्च मन्युपतयश्च मन्युकृतेभ्य:। पापेभ्यो रक्षन्ताम्।
              यत् रात्रिया पापमकार्षम्। मनसा वाचा हस्ताभ्याम्। पद्भ्याम्
              उदरेण श्श्ज्ञाि। रात्रिस्तत् अवलुम्पत्। यत्किञ्च दुरितं मयि।
              इदमहं माममृतयोनौ। सूर्ये ज्योतिषि जुहोमि स्वाहा
              ।।
                   </div></td></tr></table></div>
      </mat-expansion-panel>
      <mat-expansion-panel>
        <mat-expansion-panel-header>06-புந:ப்ரோக்ஷணம்</mat-expansion-panel-header>
        <div class="div3">
        <table>
          <tr><td style="width: 20%;">
            <img src="assets/img/Nyaasam1.jpg">
          </td><td style="width: 80%;">
            <span class="hint"> தலையைத் தொட்டு :</span>
           <span class="sans"> ததிக்ராவ்ண இதி மந்த்ரஸ்ய வாமதேவ ருஷி:&nbsp;&nbsp;
            दधिक्राव्ण्ण इति मन्त्रस्य वामदेव ऋषि: । </span>
          </td></tr> 
          
          <tr><td style="width: 20%;">
            <img src="assets/img/Nyaasam2.jpg">
          </td><td style="width: 80%;">
            <span class="hint">மூக்கைத் தொட்டு :-</span>
            <span class="sans"> அநுஷ்டுப் சந்த:&nbsp;&nbsp;
              अनुष्टुप् छन्द: </span>
          </td></tr> 
          
          <tr><td style="width: 20%;">
            <img src="assets/img/Nyaasam3.jpg">
          </td><td style="width: 80%;">
            <span class="hint">மார்பைத் தொட்டு :-</span>
            <span class="sans"> ததிக்ராவா தேவதா&nbsp;&nbsp;
              दधिक्रावा देवता </span>
          </td></tr> 
          
          <tr><td style="width: 20%;">
            <img src="assets/img/Nyaasam4.jpg">
          </td><td style="width: 80%;">
            <span class="hint">இரு கைகளையும் உட்புறமாகத் திருப்பி:</span>
            <span class="sans"> அபாம் ப்ரோக்ஷணே விநியோக:&nbsp;&nbsp;
              अपाम् प्रोक्षणे विनियोग:।
               </span>
          </td></tr>                     
                  </table>
                <div class="mydiv"> <span class="hint">ப்ரதி மந்த்ரம் தலையில் தீர்த்தம் ப்ரோக்ஷித்துக்கொள்ளவேண்டும் </span>
                    <span class="sans">
                      <br>ஓம் ததிக்ராவிண்ணோ அகார்ஷம் “
                      <br>ஜிஷ்ணோரஸ்வஸ்ய வாஜிந:“
                      <br>ஸுரபிநோ முகாகரத் “
                      <br>ப்ரண ஆயூகும்ஷி தாரிஷத் “
                      <br>ஆபோஹிஷ்டா மயோபுவ: “
                      <br>தானஊர்ஜே ததாநா “
                      <br>மஹேராணாய க்ஷக்சஸே”
                      <br>யோவஸ்சிவதமோ ரஸ: “
                      <br>தஸ்யபாஜயதேஹந: “
                      <br>உசதீரிவ மாதர:”
                      <br>தஸ்மா அரங்கமாமவ:
                      <br> தஸ்மா அரங்கமாமவ:</span>
                    <span class="hint">அடுத்த மந்திரத்திற்கு மட்டும் முழங்கால்களில் ப்ரோக்ஷணம்</span>
                    <span class="sans">யஸ்யக்ஷயாய ஜிந்வதா</span>
                    <span class="hint">பின் மீண்டும் தலையில்</span>
                    <span class="sans"> ஆபோஜநயதாஜந:</span>
                    <span class="hint">தலையைச்சுற்றி</span>
                    <span class="sans">ஓம் பூர்புவஸ்சுவ:” </span>
                    <span class="hint">என்று தீர்த்தம் விடறது.</span>
                    <span class="sans">
                      दधिक्राव्ण्णो अकारिषम।
                      <br> जिष्णोरश्वस्य वाजिन:।
                      <br> सुरभिनो मुखाकरत् ।
                      <br> प्रण आयूँषि तारिषत्।
                      <br> आपोहिष्ठा मयोॅाुव:।
                      <br> ता न उूर्जे दधातन।
                      <br> महेरणाय चक्षसे।
                      <br> योव: शिवतमो रस:।
                      <br> तस्य भाजयतेहन:।
                      <br> उशतीरिव मातर:।
                      <br> तस्मा अरङ्गमामव:।
                      <br> यस्यक्षयाय जिन्वथ।
                      <br> आपो जनयथा च न:।
                      <br> ओं भूर्भुवस्सुव:।
                                </span>
                </div> </div>
                    </mat-expansion-panel>
      <mat-expansion-panel>
        <mat-expansion-panel-header>07-ஆக்ரணம் </mat-expansion-panel-header>
        <div class="div3"> <table>
<tr><td style="width: 20%;">
  <img src="assets/img/Nyaasam1.jpg" class="img2">
</td><td style="width: 80%;">
  <span class="hint"> தலையைத் தொட்டு :</span>
 <span class="sans"> துருபதாதிவ மந்த்ரஸ்ய கோகுல ராஜபுத்ர ருஷி:&nbsp;&nbsp;
  द्रुपदाादिव मन्त्रस्य गोकुल राजपुत्र ऋषि:।
  </span>
</td></tr>
            
            
            <tr><td style="width: 20%;">
  <img src="assets/img/Nyaasam2.jpg" class="img2">
</td><td style="width: 80%;">
  <span class="hint">மூக்கைத் தொட்டு :-</span>
  <span class="sans">அநுஷ்டுப் சந்த:&nbsp;&nbsp;अनुष्टुप् छन्द: </span>
</td></tr>            
           <tr><td style="width: 20%;">
  <img src="assets/img/Nyaasam3.jpg" class="img2">
</td><td style="width: 80%;">
  <span class="hint">மார்பைத் தொட்டு :-</span>
  <span class="sans">த்ருபதா தேவதா &nbsp;&nbsp; द्रुपदा देवता</span>
</td></tr> 
           
            <tr><td style="width: 20%;">
  <img src="assets/img/Nyaasam4.jpg" class="img2">
</td><td style="width: 80%;">
  <span class="hint">இரு கைகளையும் உட்புறமாகத் திருப்பி:</span>
  <span class="sans">ஆக்ராணே விநியோக: &nbsp;&nbsp;आघ्राणे विनियोग:।
     </span>
</td></tr>            
</table>  
            
          <div class="hint">
            உள்ளங்கை நிறைய நீர் எடுத்து மந்திரம் முடிந்ததும் முகர்ந்துவிட்டு கீழே விடவும்.
          </div>
          <div class="sans">
            "த்ருபதாதிவ முஞ்சது, த்ருபதாதிவேந் முமுசாந: ஸ்விந்நஸ்நாத்வீ மலாதிவ, பூதம் பவித்ரேணேவாஜ்யம், ஆப:சுந்தந்து மைநஸ:" ’
          </div>
          <div class="sans">
            द्रपदादिव मुञ्चतु। दुपदादिवेन्मुमुचान:।स्विन्न:स्नात्वी मलादिव। पूतं पवित्रेणेवाज्यम्। आपश्शुन्धन्तु मैनस:।। ।
          </div> </div> </mat-expansion-panel>      
      <mat-expansion-panel>
        <mat-expansion-panel-header>08-அர்க்யம் </mat-expansion-panel-header>
        <div class="div3"><div class="hint">ப்ராணாயாமம் - (ஆரம்பம் பார்த்து பண்ணி)</div>
          <div class="sans">
            <table>
              <tr>
                <td><img src="assets/svg/vkThiruman.svg" class="svgs" >
                  ஸ்ரீபகவதாஜ்ஞயா ஸ்ரீமந்நாராயண ப்ரீத்யர்த்தம்</td>
                <td>
                  <img src="assets/svg/tkThiruman.svg" class="svgs">
                  ஸ்ரீபகவதாஜ்ஞயா பகவத் கைங்கர்ய ரூபம்</td>
              </tr>
            </table> 
            <mat-tab-group  mat-stretch-tabs class="mydiv">
              <mat-tab label="காலை">
                ப்ராதஸ் ஸந்த்யா அர்க்ய ப்ரதானம் கரிஷ்யே.    <br>
              </mat-tab>
              <mat-tab label="மதியம்">
                மாத்யாஹ்நிக ஸந்த்யா அர்க்ய ப்ரதானம் கரிஷ்யே.<br>
              </mat-tab>
              <mat-tab label="மாலை">
                ஸாயம் ஸந்த்யா அர்க்ய ப்ரதானம் கரிஷ்யே.<br>
              </mat-tab>
            </mat-tab-group>
          </div>
          <div class="hint">
            என்று ஸங்கல்பித்துக்கொண்டு
          </div>

  <table>
<tr><td style="width: 20%;">
  <img src="assets/img/Nyaasam1.jpg" class="img2">
</td><td style="width: 80%;">
  <span class="hint"> தலையைத் தொட்டு :</span>
 <span class="sans">அர்க்யப்ரதான மந்த்ரஸ்ய விச்வாமித்ர ருஷி: &nbsp;&nbsp;अर्घ्यप्रदान मन्त्रस्य विश्वामित्र ऋषि:।
  </span>
</td></tr>
              <tr><td style="width: 20%;">
  <img src="assets/img/Nyaasam2.jpg" class="img2">
</td><td style="width: 80%;">
  <span class="hint">மூக்கைத் தொட்டு :-</span>
  <span class="sans">தேவீ காயத்ரீ சந்த:&nbsp;&nbsp;देवी गायत्री छन्द: </span>
</td></tr> 
 <tr><td style="width: 20%;">
  <img src="assets/img/Nyaasam3.jpg" class="img2">
</td><td style="width: 80%;">
  <span class="hint">மார்பைத் தொட்டு :-</span>
  <span class="sans">ஸவிதா தேவதா &nbsp;&nbsp;सविता देवता </span>
</td></tr>  
              <tr><td style="width: 20%;">
  <img src="assets/img/Nyaasam4.jpg" class="img2">
</td><td style="width: 80%;">
  <span class="hint">இரு கைகளையும் உட்புறமாகத் திருப்பி:</span>
  <span class="sans">அர்க்ய ப்ரதாநே விநியோக: &nbsp;&nbsp; अर्घ्यप्रदाने विनियोग:।
     </span>
</td></tr>            
</table>  
          <div class="hint">
            <img src="assets/img/DevaTheertham1.jpg" class="img2"> தீர்த்த பாத்திரத்தை இடதுகை ஆட்காட்டி விரல் மற்றும் கட்டை விரல்களுக்கிடையில் இடுக்கிக்கொண்டு
            <br> மந்திரம் முடிந்ததும் சாய்த்து உள்ளங்கையில் தீர்த்தம் பெற்றுக்கொண்டு, இரண்டு கைகளின் நுனிவிரல்கள் வழியாக விடவேண்டும்.</div>
          <div class="sans">ஓம் பூர் புவஸ்ஸுவ: தத்ஸவிதுர் வரேண்யம் பர்கோ தேவஸ்ய தீமஹி தியோயோந:ப்ரசோதயாத் “ </div>
          <div class="hint"> இதுபோல் 3 தரம் - அர்க்யம் விடும்போது குதிகாலை சற்றே தூக்கி விடுவது முறையாகும்.
            <br> காலை சூரிய உதயத்திற்கு முன்பும்
            <br> மதியம் 12 மணிக்கு முன்னதாகவும்
            <br> மாலை சூரிய அஸ்தமனத்திற்கு முன்பும்
            <br> அர்க்யம் விட்டுவிடவேண்டும்.
            <br> அப்படி காலம் தவறினால்</div>
            <span class="sans"> “காலாதீத ப்ராயச்சித்த அர்க்ய ப்ரதானம் கரிஷ்யே”</span>
          <div class="hint">என்று ஸங்கல்பித்துக்கொண்டு மீண்டும் ஒரு அர்க்யம் விடவேண்டும்.
          </div></div>
      </mat-expansion-panel>
    <mat-expansion-panel>
        <mat-expansion-panel-header>09 - அஸாவாதித்யோ </mat-expansion-panel-header>
        <div class="div3"> <div class="hint">
        வலது கையில் தீர்த்தம் வாங்கி தன்னைத்தானே ப்ரதக்ஷிணமாக சுற்றிக்கொண்டே தீர்த்தத்தை வட்டமாக விசிறி விட்டு
      </div>
      <div class="sans">"ஓம் பூர்புவஸ்ஸுவ: அஸாவாதித்யோ ப்ரஹ்மா</div>
      <div class="sans">ओं भूर्भुवस्सुव: असावादित्यो ब्रह्म ।</div>
      <div class="hint">என்று கூறி, (ஆரம்பத்தில் பார்த்து)
        <br> தலைப்பு 1ன் படி ஆசமனம் பண்ணவும்
      </div></div>
    </mat-expansion-panel>
    <mat-expansion-panel>
        <mat-expansion-panel-header>10-கேஸவாதி தர்பணம் </mat-expansion-panel-header>
        <div class="div3"><div class="hint">
        தீர்த்த பாத்திரத்திலிருந்து தீர்த்தம் சரித்து வலது நுனிவிரல்கள் வழியாக ஒவ்வொரு மந்திரத்திற்கும் ஒரு முறை தரையில் விடவும்</div>
      <div class="sans">ஒம் கேசவம் தர்பயாமி”
        <br>ஓம் நாராயணம் தர்பயாமி”
        <br>ஓம் மாதவம் தர்பயாமி”
        <br>ஓம் கோவிந்தம் தர்பயாமி”
        <br>ஒம் விஷ்ணும் தர்பயாமி”
        <br>ஓம் மதுசூதனம் தர்பயாமி”
        <br>ஓம் திரிவிக்ரமம் தர்பயாமி”
        <br>ஓம் வாமனம் தர்பயாமி”
        <br>ஓம் ஸ்ரீதரம் தர்பயாமி “
        <br>ஓம் ருஷிகேசம் தர்பயாமி”
        <br>ஓம் பத்மநாபம் தர்பயாமி”
        <br>ஓம் தாமோதரம் தர்பயாமி.</div>
      <div class="sans">
        ओम् केशवं तर्पयामि।
        <br> ओम् नारायणं तर्पयामि।
        <br> ओम् माधवं तर्पयामि।
        <br> ओम् गोविन्दं तर्पयामि।
        <br> ओम् विष्णुं तर्पयामि।
        <br> ओम् मधुसूदनं तर्पयामि।
        <br> ओम् त्रिविक्रमं तर्पयामि।
        <br> ओम् वामनं तर्पयामि।
        <br> ओम् श्रीधरं तर्पयामि।
        <br> ओम् ऋषीकेशं तर्पयामि।
        <br> ओम् पद्मनाभं तर्पयामि।
        <br> ओम् दामोदरं तर्पयामि।</div>
      <div class="hint">
        தலைப்பு 1ன் படி ஆசமனம் பண்ணவும்
      </div></div>
    </mat-expansion-panel>
    <div class="head2">ஜப விதி (உள்ளே)</div>
      <mat-expansion-panel>
          <mat-expansion-panel-header>11-ஆஸன மந்த்ரம் </mat-expansion-panel-header>
          <div class="div3">  <div class="hint">
          ஜபம் பண்ண உட்காரும் இடத்தை </div>
        <div class="sans">ஓம் பூர்புவஸ்சுவ:</div>
        <div class="hint"> என்று ப்ரோக்ஷித்து அங்கே நின்று கொண்டு</div>
          <table>
<tr><td style="width: 20%;">
  <img src="assets/img/Nyaasam1.jpg" class="img2">
</td><td style="width: 80%;">
  <span class="hint"> தலையைத் தொட்டு :</span>
 <span class="sans">ஆஸந மந்த்ரஸ்ய ப்ருதிவ்யா மேருப்ருஷ்ட
  ருஷி: &nbsp;&nbsp;आसनमन्त्रस्य पृथिव्या मेरुपृष्ठ ऋषि:।
  </span>
</td></tr>
          <tr><td style="width: 20%;">
  <img src="assets/img/Nyaasam2.jpg" class="img2">
</td><td style="width: 80%;">
  <span class="hint">மூக்கைத் தொட்டு :-</span>
  <span class="sans">சுதலம் சந்த:&nbsp;&nbsp; सुतलं छन्द:। </span>
</td></tr> 
         <tr><td style="width: 20%;">
  <img src="assets/img/Nyaasam3.jpg" class="img2">
</td><td style="width: 80%;">
  <span class="hint">மார்பைத் தொட்டு :-</span>
  <span class="sans"> ஸ்ரீகூர்மோ தேவதா&nbsp;&nbsp;श्रीकूर्मो देवता </span>
</td></tr> 
          
          <tr><td style="width: 20%;">
  <img src="assets/img/Nyaasam4.jpg" class="img2">
</td><td style="width: 80%;">
  <span class="hint">இரு கைகளையும் உட்புறமாகத் திருப்பி:</span>
  <span class="sans">ஆஸநே விநியோக: &nbsp;&nbsp;आसने विनियोग:।
     </span>
</td></tr>            
</table>  
          
        <div class="hint"> எனக் கூறி</div>
        <div class="sans">கூர்மாஸனாய நம: கமலாஸனாய நம:
          <br> விமலாஸனாய நம: யோகாஸனாய நம:
          <br> ப்ருதிவித்வயா த்ருதா லோகா தேவித்வம் விஷ்ணுநாத்ருதா
          <br> த்வம்ச தாரயமாம் தேவி பவித்ரம் குருசாஸநம்</div>
        <div class="hint"> என்று ந்யாசம் செய்து அவ்விடத்தில் சம்மணமிட்டு உட்காரவும்</div>
        <div class="sans">
          कूर्मासनाय नम:।
          <br> कमलासनाय नम:।
          <br> विमलासनाय नम: ।
          <br> पद्मासनाय नम:।
          <br> योगासनाय नम: ।
          <br> पृथ्वि त्वया धृता लोका देवि त्वं विष्णुना धृता ।
          <br> त्वं च धारय मां देवि पवित्रं कुरु चासनम् ।।
          <div class="hint"> தலைப்பு 2ன் படி - ப்ராணாயாமம்.
          </div>
        </div></div>
      </mat-expansion-panel>
      <mat-expansion-panel>
          <mat-expansion-panel-header>12-ஜப ஸங்கல்பம் </mat-expansion-panel-header>
          <div class="div3">   <table>
            <tr><td style="width: 15%;">
              <img src="assets/svg/vkThiruman.svg" class="svgs" >
            </td><td style="width: 85%;">
              
             <span class="sans"> ஸ்ரீபகவதாஜ்ஞயா ஸ்ரீமந்நாராயண ப்ரீத்யர்த்தம்
              </span>
            </td></tr> 
            <tr><td style="width: 15%;">
              <img src="assets/svg/tkThiruman.svg" class="svgs">
            </td><td style="width: 85%;">
              
             <span class="sans"> ஸ்ரீபகவதாஜ்ஞயா பகவத் கைங்கர்ய ரூபம்
              </span>
            </td></tr>
          </table>
          <mat-tab-group  mat-stretch-tabs >
            <mat-tab label="காலை">
            <span class="sans">  ப்ராதஸ் ஸந்த்யா காயத்ரீ மஹா மந்த்ர ஜபம் கரிஷ்யே.|   <br>
                प्रातस् सन्ध्या गायत्री महा मन्त्र जपम् करिष्ये । </span>
            </mat-tab>
            <mat-tab label="மதியம்">
            <span class="sans">  மாத்யாஹ்நிக ஸந்த்யா காயத்ரீ மஹா மந்த்ர ஜபம் கரிஷ்யே.|<br>
              मात्याह्निग सन्ध्या गायत्री महा मन्त्र जपम् करिष्ये । </span>

            </mat-tab>
            <mat-tab label="மாலை">
           <span class="sans">   ஸாயம் ஸந்த்யா காயத்ரீ மஹா மந்த்ர ஜபம் கரிஷ்யே.|<br>
              सायम्सन्ध्या गायत्री महा मन्त्र जपम् करिष्ये । </span>
            </mat-tab>
          </mat-tab-group>
    
          </div>
</mat-expansion-panel>
      <mat-expansion-panel>
          <mat-expansion-panel-header>13-மஹா ந்யாஸம் </mat-expansion-panel-header>
          <div class="div3">    <table>
<tr><td style="width: 20%;">
  <img src="assets/img/Nyaasam1.jpg" class="img2">
</td><td style="width: 80%;">
  <span class="hint"> தலையைத் தொட்டு :</span>
 <span class="sans">ப்ரணவஸ்ய ருஷி ப்ரஹ்மா &nbsp;&nbsp;प्रणवस्य ऋषि: ब्रह्मा
  </span>
</td></tr>
          <tr><td style="width: 20%;">
  <img src="assets/img/Nyaasam2.jpg" class="img2">
</td><td style="width: 80%;">
  <span class="hint">மூக்கைத் தொட்டு :-</span>
  <span class="sans">தேவீ காயத்ரீ சந்த:&nbsp;&nbsp;देवी गायत्री छन्द: </span>
</td></tr> 
         
         <tr><td style="width: 20%;">
  <img src="assets/img/Nyaasam3.jpg" class="img2">
</td><td style="width: 80%;">
  <span class="hint">மார்பைத் தொட்டு :-</span>
  <span class="sans">பரமாத்மா ஸ்ரீமந் நாராயணோ தேவதா &nbsp;&nbsp;परमात्मा श्रीमन्नारायणो देवता </span>
</td></tr>       
        
<tr><td style="width: 20%;">
  <img src="assets/img/Nyaasam1.jpg" class="img2">
</td><td style="width: 80%;">
  <span class="hint"> தலையைத் தொட்டு :</span>
 <span class="sans"> பூராதி ஸப்த வ்யாஹ்ருதீநாம்
  அத்ரி, ப்ருகு, குத்ஸ, வசிஷ்ட, கௌதம, காச்யப,
  அங்கீரஸ ருஷய:&nbsp;&nbsp;भूरादि सप्त व्याहृतीनां अत्रि, भृगु, कुत्स, वसिष्ठ,
  गौतम, काश्यप, आङ्गिरस ऋषय: ।
  </span>
</td></tr>
          <tr><td style="width: 20%;">
  <img src="assets/img/Nyaasam2.jpg" class="img2">
</td><td style="width: 80%;">
  <span class="hint">மூக்கைத் தொட்டு :-</span>
  <span class="sans">காயத்ரி, உஷ்ணிக், அநுஷ்டுப்,
    ப்ருஹதி, பங்க்தி, த்ருஷ்டுப், ஜகத்ய: சந்தா(கு)ம்ஸி&nbsp;&nbsp;गायत्रि, उष्णिग्, अनुष्टुप्, बृहति, पङ्क्ति, त्रिष्टुप्,
    जगत्य: छन्दाँसि । </span>
</td></tr> 
          
         <tr><td style="width: 20%;">
  <img src="assets/img/Nyaasam3.jpg" class="img2">
</td><td style="width: 80%;">
  <span class="hint">மார்பைத் தொட்டு :-</span>
  <span class="sans">அக்னி, வாயு, அர்க்க, வாகீச,
    வருண, இந்த்ர, விச்வேதேவா தேவதா: &nbsp;&nbsp;अग्नि, वायु, अर्क, वागीश, वरुण, इन्द्र,
    विश्वेदेवा देवता: । </span>
</td></tr> 
     
<tr><td style="width: 20%;">
  <img src="assets/img/Nyaasam1.jpg" class="img2">
</td><td style="width: 80%;">
  <span class="hint"> தலையைத் தொட்டு :</span>
 <span class="sans">ஸாவித்ரியா ருஷி: விச்வாமித்ர: &nbsp;&nbsp;सावित्र्या ऋषि: विश्वामित्र: ।
  </span>
</td></tr>
          
          <tr><td style="width: 20%;">
  <img src="assets/img/Nyaasam2.jpg" class="img2">
</td><td style="width: 80%;">
  <span class="hint">மூக்கைத் தொட்டு :-</span>
  <span class="sans"> தேவீ காயத்ரி சந்த:&nbsp;&nbsp;देवी गायत्री छन्द: </span>
</td></tr> 
         <tr><td style="width: 20%;">
  <img src="assets/img/Nyaasam3.jpg" class="img2">
</td><td style="width: 80%;">
  <span class="hint">மார்பைத் தொட்டு :-</span>
  <span class="sans">ஸவிதா தேவதா &nbsp;&nbsp;सविता देवता । </span>
</td></tr> 
      
<tr><td style="width: 20%;">
  <img src="assets/img/Nyaasam1.jpg" class="img2">
</td><td style="width: 80%;">
  <span class="hint"> தலையைத் தொட்டு :</span>
 <span class="sans"> காயத்ரீ சிரஸ: ப்ரஹ்மா ருஷி:&nbsp;&nbsp;गायत्री शिरस: ब्रह्मा ऋषि:।
  </span>
</td></tr>
          <tr><td style="width: 20%;">
  <img src="assets/img/Nyaasam2.jpg" class="img2">
</td><td style="width: 80%;">
  <span class="hint">மூக்கைத் தொட்டு :-</span>
  <span class="sans">அநுஷ்டுப் சந்த:&nbsp;&nbsp;अनुष्टुप् छन्द:। </span>
</td></tr>
         <tr><td style="width: 20%;">
  <img src="assets/img/Nyaasam3.jpg" class="img2">
</td><td style="width: 80%;">
  <span class="hint">மார்பைத் தொட்டு :-</span>
  <span class="sans">பரமாத்மா ஸ்ரீமந்நாராயணோ தேவதா &nbsp;&nbsp;परमात्मा श्रीमन्नारायणो देवता </span>
</td></tr> 
         
          <tr><td style="width: 20%;">
  <img src="assets/img/Nyaasam4.jpg" class="img2">
</td><td style="width: 80%;">
  <span class="hint">இரு கைகளையும் உட்புறமாகத் திருப்பி:</span>
  <span class="sans"> ஸர்வேஷாம் ஜபே விநியோ:&nbsp;&nbsp;सर्वेषाम् जपेविनियोग:।
     </span>
</td></tr>            
</table> 
        <div class="hint">மூன்று ப்ராணாயாமம் பண்ணவும்</div></div>
      </mat-expansion-panel>
      <mat-expansion-panel>
          <mat-expansion-panel-header>14- காயத்ரி ஆவாஹனம் </mat-expansion-panel-header>
          <div class="div3">     <table>
<tr><td style="width: 20%;">
  <img src="assets/img/Nyaasam1.jpg" class="img2">
</td><td style="width: 80%;">
  <span class="hint"> தலையைத் தொட்டு :</span>
 <span class="sans">ஆயாதிதி அநுவாகஸ்ய
  வாமதேவ ருஷி: &nbsp;&nbsp;आयात्विति अनुवाकस्य वामदेव ऋषि:।
  </span>
</td></tr>
          <tr><td style="width: 20%;">
  <img src="assets/img/Nyaasam2.jpg" class="img2">
</td><td style="width: 80%;">
  <span class="hint">மூக்கைத் தொட்டு :-</span>
  <span class="sans">அநுஷ்டுப் ஜகத்யௌ சந்தா(கு)ம்ஸி&nbsp;&nbsp;अनुष्टुप् जगत्यौ छान्दाँसि </span>
</td></tr> 
         <tr><td style="width: 20%;">
  <img src="assets/img/Nyaasam3.jpg" class="img2">
</td><td style="width: 80%;">
  <span class="hint">மார்பைத் தொட்டு :-</span>
  <span class="sans">காயத்ரீ தேவதா &nbsp;&nbsp;गायत्री देवता। </span>
</td></tr> 
       
          <tr><td style="width: 20%;">
  <img src="assets/img/Nyaasam4.jpg" class="img2">
</td><td style="width: 80%;">
  <span class="hint">இரு கைகளையும் உட்புறமாகத் திருப்பி:</span>
  <span class="sans">காயத்ரீ ஆவாஹநே விநியோக: &nbsp;&nbsp;गायत्री आवाहने विनियोग:।
     </span>
</td></tr>            
</table>  
          <img src="assets/img/kaikoopu.jpg" class="img2">
          <span class="hint">கையைக் கூப்பிக்கொண்டு சொல்லவும் </span>
        <span class="sans">
          "ஆயாது வரதா தேவி அக்ஷரம் ப்ரஹ்ம ஸம்மிதம்
          காயத்ரீம் சந்தஸாம் மாதா இதம் ப்ரஹ்ம்ம ஜுஷஸ்வந:
           ஓஜோஸி ஸஹோஸி பலமஸி ப்ராஜோஸி தேவாநாம்
          தாமநாமாஸி விச்வமஸி விச்வாயு: ஸர்மஸி ஸர்வாயு:
          அபிபூரோம் காயத்ரீம் ஆவாஹயாமி (ஸாவித்ரீம் ஆவாஹயாமி ஸரஸ்வதீம் ஆவாஹயாமி)"
          <br> आयातु वरदाा देवी अक्षरं ब्रह्मसंमितम्।
            <br> गायत्रीं छन्दसां माता इदं ब्रह्म जुषस्व न:।।
            <br> ओजोऽसि सहोसि बलमसि भ्राजोऽसि देवानां धामनामासि विश्वमसि विश्वायु: सर्वमसि सर्वायु: अभिभूरों गायत्रीम् आवाहयामि।
            (सावित्रीम् आवाहयामि, सरस्वतीम् आवाहयामि)
        </span>
          <span class="hint">என்று காயத்ரீயை ஆவாஹனம் பண்ணிக்கொண்டு
          </span></div>
    </mat-expansion-panel>
      <mat-expansion-panel>
          <mat-expansion-panel-header>15- த்யானம் </mat-expansion-panel-header>
          <div class="div3">     <img src="assets/img/kaikoopu.jpg" class="img2">
        <span class="sans"> ப்ராதர் த்யாயாமி காயத்ரீம் ரவி மண்டல மத்யகாம்
          <br>ருக்வேதமுச்சாரயந்தீம் ரக்தவர்ணாம் குமாரிகாம்
          <br> அக்ஷமாலாகராம் ப்ரஹ்ம தைவத்யாம் ஹம்ஸவாஹநாம்
       <br>
          प्रातर्ध्यायामि गायत्रीं रविमण्डल मध्यगाम्।
          <br> ऋग्वेदमुच्चारयन्तीं रक्तवर्णां कुमारिकाम्।
          <br> अक्षमालाकरां ब्रह्मदैवत्यां हंसवाहानाम्।।</span></div>
          <table>
<tr><td style="width: 20%;">
  <img src="assets/img/Nyaasam1.jpg" class="img2">
</td><td style="width: 80%;">
  <span class="hint"> தலையைத் தொட்டு :</span>
 <span class="sans"> ஸாவித்ரியா ருஷி: விச்வாமித்ர: &nbsp;&nbsp;सावित्र्या ऋषि: विश्वामित्र:
  </span>
</td></tr>
         
          <tr><td style="width: 20%;">
  <img src="assets/img/Nyaasam2.jpg" class="img2">
</td><td style="width: 80%;">
  <span class="hint">மூக்கைத் தொட்டு :-</span>
  <span class="sans">தேவீ காயத்ரீ சந்த:&nbsp;&nbsp; देवी गायत्री छन्द:</span>
</td></tr> 
         <tr><td style="width: 20%;">
  <img src="assets/img/Nyaasam3.jpg" class="img2">
</td><td style="width: 80%;">
  <span class="hint">மார்பைத் தொட்டு :-</span>
  <span class="sans">ஸவிதா தேவதா &nbsp;&nbsp; सविता देवता</span>
</td></tr> 
          </table>     

  <img src="assets/img/kaikoopu.jpg" class="img2">
  <span class="hint">கையைக் கூப்பிக்கொண்டு சொல்லவும் </span>
  <span class="sans">சங்கச்சக்ர தரம் தேவம் கிரீடாதி விபூஷிதம் ஸூர்ய மண்டல மத்யஸ்த்தம் த்யாயேத் ஸ்வர்ணருசிம் ஹரிம் யோதேவ: ஸவிதா அஸ்மாகம் த்யோ
          தர்மாதி கோசரா: ப்ரேரயேத் தஸ்ய யத்பர்க்க: தத்வரேண்யம் உபாஸ்மஹே.
       शंकचक्रधरं देवं किरीटादि विभूषितम्।
          <br> सूर्यमण्डल मध्यस्थं ध्यायेत् स्वर्ण रुचिं हरिम्।।
          <br> योदेव: सविता अस्माकं धियो धर्मादि गोचरा:।
          <br> प्रेरयेत् तस्य यद्भर्ग: तद्वरेण्यम् उपास्महे।।</span>
        <span class="hint">
          என்று த்யானித்து</span>
       
     </mat-expansion-panel>
          <mat-expansion-panel>
          <mat-expansion-panel-header>16-காயத்ரி ஜபம் </mat-expansion-panel-header>
          <div class="div3">  <div class="hint">
          1008 அல்லது 108 அல்லது குறைந்தது 28 தரம் காயத்ரி ஜபம் பண்ணவும் </div>
        <div class="hint">
          காயத்ரியை 5 பாதங்களாக மனதிற்குள் ஜபிக்கவேண்டும்.
        </div>
        <hr style="color:red;">
        <div class="sans">
          1. ஓம்
          <br>2. பூர்புவஸ்ஸுவ:
          <br> 3. தத்ஸவிதுர்வரேணியம்
          <br> 4. பர்க்கோதேவஸ்ய தீமஹி
          <br> 5. தியோயோந: ப்ரசோதயாத் </div>
        <div class="sans">१) ओम्
          <br>२) भूर्भुवस्सुव:
          <br> ३) तत्सवितुर्वरेणियम्
          <br>४) भर्गो देवस्य धीमहि
          <br> ५) धियोयोन:प्रचोदयात्।</div>
        <div class="hint">
          (என 5 இடங்களில் நிறுத்தி) காயத்ரீ ஜபம் பண்ணவும்
          <br> கீழே காயத்ரி ஜபம் பண்ணும் முறை வீடியோவில் தெளிவாகக் காணலாம்.
        </div>
        <ion-item>
          <div class="video-container">
            <iframe src="https://www.youtube.com/embed/tBoj6eSjc6g?rel=0" frameborder="0" width="300" height="169"></iframe>
          </div>
        </ion-item>
        <div class="hint"> காயத்ரி ஜபம் முடிந்ததும் ப்ராணாயாமமம் பண்ணவும் </div>
  </div>
      </mat-expansion-panel>
      <mat-expansion-panel>
          <mat-expansion-panel-header>17- காயத்ரி உத்வாஸனம்</mat-expansion-panel-header>
          <div class="div3">  <table><tr><td style="width: 15%;">
          
          <img src="assets/img/Sankalpam.jpg" class="img2"> </td>
          <td style="width: 85%;">
          <span class="hint">காயத்ரி உத்வாஸன ஸங்கல்பம்:</span></td>
          
            <tr><td style="width: 15%;">
              <img src="assets/svg/vkThiruman.svg" class="svgs" >
            </td><td style="width: 85%;">
              
             <span class="sans"> ஸ்ரீபகவதாஜ்ஞயா ஸ்ரீமந்நாராயண ப்ரீத்யர்த்தம்
              </span>
            </td></tr> 
            <tr><td style="width: 15%;">
              <img src="assets/svg/tkThiruman.svg" class="svgs">
            </td><td style="width: 85%;">
              
             <span class="sans"> ஸ்ரீபகவதாஜ்ஞயா பகவத் கைங்கர்ய ரூபம்
              </span>
            </td></tr>
          </table>
        <div class="sans"> காயத்ரி உத்வாஸனம் கரிஷ்யே!
          &nbsp;&nbsp;
          गायत्रि उद्वासनम् करिष्ये।</div>
          <table>
<tr><td style="width: 20%;">
  <img src="assets/img/Nyaasam1.jpg" class="img2">
</td><td style="width: 80%;">
  <span class="hint"> தலையைத் தொட்டு :</span>
 <span class="sans">உத்தம இதி அநுவாகஸ்ய வாமதேவ ருஷி: &nbsp;&nbsp;उत्तम इति अनुवाकस्य वामदेव ऋषि:
  </span>
</td></tr>
         
          <tr><td style="width: 20%;">
  <img src="assets/img/Nyaasam2.jpg" class="img2">
</td><td style="width: 80%;">
  <span class="hint">மூக்கைத் தொட்டு :-</span>
  <span class="sans">அநுஷ்டுப் சந்த: &nbsp;&nbsp;अनुष्टुप् छन्द: </span>
</td></tr> 
  
         <tr><td style="width: 20%;">
  <img src="assets/img/Nyaasam3.jpg" class="img2">
</td><td style="width: 80%;">
  <span class="hint">மார்பைத் தொட்டு :-</span>
  <span class="sans">காயத்ரி தேவதா &nbsp;&nbsp;गायत्री देवता  </span>
</td></tr> 
        
          <tr><td style="width: 20%;">
  <img src="assets/img/Nyaasam4.jpg" class="img2">
</td><td style="width: 80%;">
  <span class="hint">இரு கைகளையும் உட்புறமாகத் திருப்பி:</span>
  <span class="sans">காயத்ரி உத்வாஸநே விநியோக: &nbsp;&nbsp;गायत्री उद्वासने विनियोग:।
     </span>
</td></tr>            
</table> 
<div class="color4"><div class="div3">
  <img src="assets/img/kaikoopu.jpg" class="img2">
  <span class="hint">கையைக் கூப்பிக்கொண்டு சொல்லவும் </span>
        <span class="sans">
          "உத்தமே சிகரே தேவி பூம்யாம் பர்வதமூர்தநி ப்ராம்மணேப்ய: ஹ்யநுக்ஞானம் கச்சதேவி யதாசுகம்"
        उत्तमे शिखरे देवी भूम्यां पर्वतमूर्धनि। ब्रह्मणेभ्य: ह्यनुज्ञानं गच्छ देवि यथासुखम्।।</span></div></div>
</div>
      </mat-expansion-panel>
      <mat-expansion-panel>
          <mat-expansion-panel-header>18 - உபஸ்தானம் </mat-expansion-panel-header>
          <div class="div3">  <table><tr><td style="width: 15%;">
          
            <img src="assets/img/Sankalpam.jpg" class="img2"> </td>
            <td style="width: 85%;">
            <span class="hint">காயத்ரி உத்வாஸன ஸங்கல்பம்:</span></td>
            
              <tr><td style="width: 15%;">
                <img src="assets/svg/vkThiruman.svg" class="svgs" >
              </td><td style="width: 85%;">
                
               <span class="sans"> ஸ்ரீபகவதாஜ்ஞயா ஸ்ரீமந்நாராயண ப்ரீத்யர்த்தம்
                </span>
              </td></tr> 
              <tr><td style="width: 15%;">
                <img src="assets/svg/tkThiruman.svg" class="svgs">
              </td><td style="width: 85%;">
                
               <span class="sans"> ஸ்ரீபகவதாஜ்ஞயா பகவத் கைங்கர்ய ரூபம்
                </span>
              </td></tr>
            </table>
            <table>
              <tr>
                <td style="width: 33%;">
                  <span class="sans">    காலை: ப்ராதஸ் ஸந்த்யா &nbsp;&nbsp;प्रातस् सन्ध्या
                  </span>
                </td>
                <td style="width: 33%;">
                  <span class="sans">   மதியம்: மாத்யாஹ்நிக ஸந்த்யா&nbsp;&nbsp;
                मात्याह्निग सन्ध्या </span>
               
                </td>
                <td style="width: 33%;">
                  <span class="sans">  மாலை: ஸாயம் ஸந்த்யா&nbsp;&nbsp;
                सायम्सन्ध्या </span>
                </td>
              </tr>
             
            </table>
        <div class="sans">  உபஸ்தானம் கரிஷ்யே. &nbsp;&nbsp; उपस्थानम् करिष्ये ।</div>
        <mat-tab-group  mat-stretch-tabs class="mydiv">
          <mat-tab label="காலை">
            <table>
              <tr><td style="width: 20%;">
                <img src="assets/img/Nyaasam1.jpg" class="img2">
              </td><td style="width: 80%;">
                <span class="hint"> தலையைத் தொட்டு :</span>
               <span class="sans">மித்ரஸ்ய இதி உபஸ்தான மந்த்ரஸ்ய விச்வாமித்ர ருஷி:&nbsp;&nbsp;
                मित्रस्य इति उपस्थान मन्त्रस्य विश्वामित्र ऋषि: </span>
              </td></tr>
                        
                        <tr><td style="width: 20%;">
                <img src="assets/img/Nyaasam2.jpg" class="img2">
              </td><td style="width: 80%;">
                <span class="hint">மூக்கைத் தொட்டு :-</span>
                <span class="sans">பீருட் காயத்ரி த்ருஷ்டுப் சந்தாகும்ஸி&nbsp;&nbsp;भीरुड् गायत्री त्रिष्टुप् छन्दाँसि </span>
              </td></tr> 
                        
                       <tr><td style="width: 20%;">
                <img src="assets/img/Nyaasam3.jpg" class="img2">
              </td><td style="width: 80%;">
                <span class="hint">மார்பைத் தொட்டு :-</span>
                <span class="sans">மித்ரோ தேவதா &nbsp;&nbsp;मित्रो देवता </span>
              </td></tr> 
                       
                        <tr><td style="width: 20%;">
                <img src="assets/img/Nyaasam4.jpg" class="img2">
              </td><td style="width: 80%;">
                <span class="hint">இரு கைகளையும் உட்புறமாகத் திருப்பி:</span>
                <span class="sans">ப்ராதஸ் ஸந்த்யோபஸ்தாநே விநியோக: &nbsp;&nbsp;प्रातस्सन्ध्योपस्थाने विनियोग:।
                   </span>
              </td></tr>            
              </table>  
                      <div class="color4"><div class="div3">
                        <img src="assets/img/kaikoopu.jpg" class="img2">
                        <span class="hint">என்று ந்யாசம் பண்ணி
                          <br> பின் எழுந்து நின்று கைகூப்பிக்கொண்டு
                        </span>
                      <span class="sans">
                         ஓம் மித்ரஸ்ய ச்சர்ஷணி த்ருத: ச்ரவோ தேவஸ்ய
                        ஸாநஸிம் ஸத்யம் சித்ரச்ரவஸ்தமம் மித்ரோ ஜநாநு
                        யாதயதி ப்ராஜாநந்நு மித்ரோ தாதாரப்ருதிவீம்
                        உதத்யாம் மித்ர: க்ருஷ்டீ: அநிமிஷா அபிஷஷ்டே
                        ஸத்யாயஹவ்யம் க்ருதவத்விதேமா ப்ரஸமித்ர மர்தோ அஸ்து.
                        ப்ரயஸ்வாந் யஸ்த்த
                        ஆதித்ய சிக்ஷிதி வ்ரதேநா நஹந்யதே ந ஜீயதே
                        த்வோதோ நைநமகும்ஹ: அஸ்ஷ்ஞ்நோதி அந்திதோநதூராது
                     
                        ओं मित्रस्य चर्षणी धृत: श्रवो देवस्य सानसिम्। सत्यं चित्रश्रवस्तमम्।।
                        मित्रो जनान् यातयति प्रजानन् मित्रो दधार पृथिवीम् उतद्याम्।
                        मित्र: कृष्टी: अनिमिषा अभिचष्टे सत्याय हव्यं घृतविद्वधेम ।।
                        प्रसमित्र मर्त्तो अस्तु प्रयस्वान् यस्त आदित्य शिक्षिति
                        व्रतेन। न हन्यते न जीयते त्वोतो नैनमँहो अश्नोति अन्तितो न दूरात् ।।</span>      
                      <span class="hint">
                        என்று உதித்த ஸூரியனை (பார்க்கவும்) த்யானிக்கவும்</span>
                      </div></div>     
          </mat-tab>
          <mat-tab label="மதியம்">
            <table>
              <tr><td style="width: 20%;">
                <img src="assets/img/Nyaasam1.jpg" class="img2">
              </td><td style="width: 80%;">
                <span class="hint"> தலையைத் தொட்டு :</span>
               <span class="sans">ஆஸத்யேந இத்யாதி மந்த்ராணாம், ஹிரண்ய ஸ்தூப, விச்வாமித்ர, குத்ஸ, வசிஷ்டா ருஷய: &nbsp;&nbsp;
                आस्त्येन इत्यादि मन्त्राणां हिरण्यस्तूप विश्वामित्र कुत्स वसिष्ठा ऋषय:
                </span>
              </td></tr>
                        
                        <tr><td style="width: 20%;">
                <img src="assets/img/Nyaasam2.jpg" class="img2">
              </td><td style="width: 80%;">
                <span class="hint">மூக்கைத் தொட்டு :-</span>
                <span class="sans">த்ருஷ்டுப் காயத்ரி, ஜகதி, உஷ்ணிக், த்ருஷ்டுப் சந்தாகும்ஸி
                  &nbsp;&nbsp;  त्रिष्टुप् गायत्री जगति उष्णिग् त्रिष्टुप् छन्दाँसि। </span>
              </td></tr> 
                        
                       <tr><td style="width: 20%;">
                <img src="assets/img/Nyaasam3.jpg" class="img2">
              </td><td style="width: 80%;">
                <span class="hint">மார்பைத் தொட்டு :-</span>
                <span class="sans">ஆதித்யோ தேவதா &nbsp;&nbsp;आदित्यो देवता। </span>
              </td></tr> 
                       
                        <tr><td style="width: 20%;">
                <img src="assets/img/Nyaasam4.jpg" class="img2">
              </td><td style="width: 80%;">
                <span class="hint">இரு கைகளையும் உட்புறமாகத் திருப்பி:</span>
                <span class="sans">மாத்யாஹ்நிக ஸந்த்யோபஸ்தாநே விநியோக:
                   &nbsp;&nbsp;माध्याह्निक सन्ध्योपस्थाने विनियोग:।
                   </span>
              </td></tr>            
              </table>  
                      <div class="color4"><div class="div3">
                        <img src="assets/img/kaikoopu.jpg" class="img2">
                        <span class="hint">என்று ந்யாசம் பண்ணி
                          <br>   <br> பின் வெளியில் சென்று படத்தில் காட்டியுள்ளதுபோல் கைகளைப் பின்னிக்கொண்டு, துவாரம் வழியாக, சூர்யனை பார்த்துக்கொண்டு
                          கீழ் வரும் மந்திரத்தைச் சொல்ல வேண்டும்.
                        </span>
                      <span class="sans">
                        <img src="assets/img/surya-namaskaram-s.jpg" style="width:200px;float:left;">
                        " ஓம் ஆஸத்யேந ரஜஸா வர்த்தமாநோ நிவேசயந்
                        <br> அம்ருதம் மர்த்யஞ் ச, ஹிரண்யயேந ஸவிதாரதேந
                        <br> ஆதேவோ யாதி புவநா விபச்யந், உத்வயம் தமஸஸ்பரி
                        <br> பச்யந்தோ ஜ்யோதிருத்தரம்
                        <br> தேவம் தேவத்ரா ஸூர்யமகந்ம ஜ்யோதிருத்தமம்
                        <br> உதுத்யம் ஜாதவேதஸம் தேவம் வஹந்தி கேதவ:
                        <br> த்ருசே விச்வாய ஸூர்யம்
                        <br> சித்ரம் தேவாநாம் உதகாதநீகம்
                        <br> சக்ஷுர் மித்ரஸ்ய வருணஸ்யாக்நே:
                        <br> ஆப்ரா த்யாவாப்ருத்வீ அந்தரிக்ஷம்
                        <br> ஸூர்ய ஆத்மா ஜகதஸ்தஸ்த்துஷச்சா
                        <br> தச்சக்ஷுர் தேவஹிதம் புரஸ்தாத் சுக்ரமுச்சரத்
                        <br> பச்யேம சரதஸ்சதம்
                        <br> ஜீவேம சரதஸ்சதம்
                        <br> நந்தாம சரதஸ்சதம்
                        <br> மோதாம சரதஸ்சதம்
                        <br> பவாம சரதஸ்சதம்
                        <br> ச்ருணவாம சரதஸ்சதம்
                        <br> ப்ரப்ரவாம சரதஸ்சதம்
                        <br> அஜீதாஸ்ஸ்யாம சரதஸ்சதம்
                        <br> ஜ்யோக் ச ஸூர்யம் த்ருசே
                        <br> ய உதகாந் மஹதோ அர்ணவாத்
                        <br> விப்ராஜமாந: ஸரிரஸ்ய மத்யாத்
                        <br> ஸமாவ்ருஷபோ ரோஹிதாக்ஷ:
                        <br> ஸூர்யோ விபச்சிந் மநஸா புநாது”   
                        <hr class="orange">
                        आसत्येन रजसा वर्तमानो निवेशयन् अमृतं मर्त्यं च।
            <br> हिरण्ययेन सविता रथेना देवो याति भुवना विपश्यन्।।
            <br> उद्वयं तमसस्परि पश्यन्तो ज्योतिरुत्तरम्।
            <br> देवं देवत्रा सूर्यमगन्म ज्योतिरुत्तमम्।
            <br> उदुत्यं जातवेदसं देवं वहन्ति केतव:।
            <br> दृशेविश्वाय सूर्यम्।
            <br> चित्रं देवानामुदगादनीकं चक्षुर्मित्रस्य वरुण्स्याग्ने:।
            <br> आ प्रा द्यवापृथिवी अन्तरिक्षँ सूर्य आत्मा जगतस्तस्थुषश्च।।
            <br> तच्चक्षु: देवहितं पुरस्तात् चुक्रमच्चरत्।।
            <br> पश्येम शरदश्शतं,
            <br> जीवेम शरदश्शतं,
            <br> नन्दाम शरदश्शतं,
            <br> मोदाम शरदश्शतं,
            <br> भवाम शरदश्शतं,
            <br> शृणवाम शरदश्शतं,
            <br>प्रब्रवाम शरदश्शतं,
            <br> अजीतास्स्याम शरदश्शतं ज्योक् च सूर्यं दृशे ।।
            <br> य इदगान् महतोऽर्णवाद् विभ्राजमान: सरिरस्य मध्यात्
            <br> स मावृषभो रोहिताक्ष: सूर्यो विपश्चिन् मनसा पुनातु।
                      
                      </span>      
                      <span class="hint">
                        என்று மதிய உச்சி ஸூரியனை (பார்க்கவும்) த்யானிக்கவும்</span>
                      </div></div>   
          </mat-tab>
          <mat-tab label="மாலை">
            <table>
              <tr><td style="width: 20%;">
                <img src="assets/img/Nyaasam1.jpg" class="img2">
              </td><td style="width: 80%;">
                <span class="hint"> தலையைத் தொட்டு :</span>
               <span class="sans">இமம் மே இதி மந்த்ராணாம் தேவராத ருஷி: &nbsp;&nbsp;
                इमं मे इति मन्त्राणां देवरात ऋषि:।
                </span>
              </td></tr>
                        
                        <tr><td style="width: 20%;">
                <img src="assets/img/Nyaasam2.jpg" class="img2">
              </td><td style="width: 80%;">
                <span class="hint">மூக்கைத் தொட்டு :-</span>
                <span class="sans">காயத்ரி த்ருஷ்டுப் ஜகத்ய: சந்தாகும்ஸி&nbsp;&nbsp;गायत्री त्रिष्टुप् जगत्य: छन्दाँसि </span>
              </td></tr> 
                        
                       <tr><td style="width: 20%;">
                <img src="assets/img/Nyaasam3.jpg" class="img2">
              </td><td style="width: 80%;">
                <span class="hint">மார்பைத் தொட்டு :-</span>
                <span class="sans">வருணோ தேவதா &nbsp;&nbsp;वरुणो देवता </span>
              </td></tr> 
                       
                        <tr><td style="width: 20%;">
                <img src="assets/img/Nyaasam4.jpg" class="img2">
              </td><td style="width: 80%;">
                <span class="hint">இரு கைகளையும் உட்புறமாகத் திருப்பி:</span>
                <span class="sans">ஸாயம் ஸந்த்யோபஸ்தாநே விநியோக: &nbsp;&nbsp;सायं सन्ध्योपस्थाने विनियोग:।
                   </span>
              </td></tr>            
              </table>  
                      <div class="color4"><div class="div3">
                        <img src="assets/img/kaikoopu.jpg" class="img2">
                        <span class="hint">என்று ந்யாசம் பண்ணி
                          <br> பின் எழுந்து நின்று கைகூப்பிக்கொண்டு
                        </span>
                      <span class="sans">
                        “இமம் மே வருண ச்ருதீஹவம் அத்யாஸ்ச ம்ருடய<br>
                        த்வாமவஸ்யுராசகே<br>
                        தத்வாயாமி ப்ரஹ்மணா வந்தமானஸ் ததாசாஸ்தே<br>
                        யஜமாநோ ஹவிர்பி: <br>
                        அஹேடமாநோ வருணேஹபோதி<br>
                         உருசகும்ஸ மாந:<br>
                        ஆயு: ப்ரமோஷீ:<br>
                        யச்சித்தி தே விசோ யதா ப்ரதேவ வருண வ்ரதம்<br>
                        மிநீமஸி த்யவி த்யவி<br>
                        யத்கிஞ்சேதம் வருண தைவ்யே ஜநேபித்ரோஹம் மநுஷ்யாசராமஸி<br>
                        அசித்தி யத் தவ தர்மா யுயோபிம மாநஸ்தஸ்மா
                        தேநஸோ தேவ ரீரிஷ:<br>
                        கிதவாஸோ யத்ரிரிபு: நதீவி யத்வாகா ஸத்யமுதயந்ந வித்ம<br>
                        ஸர்வாதாவிஷ்ய சிதிரேவ தேவாதாதே ஸ்யாம வருண ப்ரியாஸ:
                        ” <hr class="orange">
                          इमं मे वरुण श्रुधी हवं अद्या च मृडय।
                          त्वामवस्युराचके ।
                          तत्त्वायामि ब्रह्मणा वन्दमान: तदााशास्ते यजमान: हविर्भि:।
                          अहेडमान: वरुणेहबोधि उरुशँस मा न आयु: प्रमोषी:।
                          यच्चिद्धि ते विशो यथा प्र देव वरुण व्रतम्।
              मिनीमसि द्यवि द्यवि।।
              यत् किं चेदं वरुण दैव्ये जनेऽभिद्रोहं मनुष्याश्चरामसि।
              अचित्ती यत् तव धर्मा युयोपिम मानस्तमादेनसो देव रीरिष:।
              कितवासो यद्रिरिपु: नदीवि यद्वाघा सत्यमुतयन्न वि़द्म।
              सर्वा ताविष्य शिथिरेव देवाथा ते स्याम वरुण प्रियास: ।।</span>      
                      <span class="hint">
                        என்று அந்தி ஸூரியனை (பார்க்கவும்) த்யானிக்கவும்</span>
                      </div></div>      
          </mat-tab>
        </mat-tab-group>    
      </div>
     </mat-expansion-panel>
       <mat-expansion-panel>
          <mat-expansion-panel-header>19 - ஸந்தி - திசா வந்தனம் </mat-expansion-panel-header>
          <div class="div3">  <mat-tab-group  mat-stretch-tabs >
            <mat-tab label="காலை">
              <div class="div3">
          <span class="hint">
          கிழக்கே பார்த்து கைகூப்பி </span>
        <span class="sans">ஓம் ஸந்த்யாயை நம:</span>
        <span class="hint"> தெற்கு பார்த்து கைகூப்பி </span>
        <span class="sans">ஸாவித்ரியை நம:</span>
        <span class="hint"> மேற்கே பார்த்து கைகூப்பி </span>
        <span class="sans"> காயத்ரியை நம:</span>
        <span class="hint"> வடக்கே பார்த்து கைகூப்பி </span>
        <span class="sans">ஸரஸ்வத்யை நம:</span>
        <span class="hint"> கிழக்கே கைகூப்பி </span>
        <span class="sans">ஸர்வாப்யோ தேவதாப்யோ நமோ நம:</span>
        <span class="sans">
          ओं सन्ध्यायै नम:।
          <br> ओं सावित्र्यै नम: ।
          <br> ओं गायत्र्यै नम: ।
          <br> ओं सरस्वत्यै नम: ।
          <br> सर्वाभ्यो देवताभ्यो नमो नम: ।
        </span>
        <span class="hint"> கிழக்குப்பார்த்து சாஷ்டாங்கமாக </span>
        <span class="sans">காமோகார்ஷீத் மந்யுர கார்ஷீத் நமோ நம:” </span>
        <span class="sans">
          कामोऽकार्षीन्मन्युरकार्षीन् नमो नम: ।
        </span>
        <img src="assets/img/shastanga.JPG" class="img1">
        <span class="hint"> என்று, வடகலை 4 தரம் - தென்கலை - 1 தரம் - ஸேவிக்கவேண்டும்.
        </span>
        <img src="assets/img/abhivathi.jpg" class="img1">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
        <span class="hint">
          அபிவாதனம் பண்ணவேண்டியது.&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
        </span>
        <span class="hint">கிழக்கே பார்த்து </span>
        <span class="sans">ஓம் ப்ராச்யை திசே நம:</span>
        <span class="hint"> தெற்கே பார்த்து </span>
        <span class="sans">தக்ஷிணாயை திசே நம: “</span>
        <span class="hint"> மேற்கே பார்த்து </span>
        <span class="sans">ப்ரதீச்யை திசே நம:</span>
        <span class="hint"> வடக்கே பார்த்து </span>
        <span class="sans">உதீச்யை திசே நம:” </span>
        <span class="hint">பின் கிழக்கே திரும்பி
          <br> மேலே பார்த்து </span>
        <span class="sans">ஊர்த்வாய நம:</span>
        <span class="hint">கீழே பார்த்து </span>
        <span class="sans">அதராய நம:</span>
        <span class="hint"> மேலே பார்த்து </span>
        <span class="sans">அந்தரிக்ஷாய நம:</span>
        <span class="hint"> பூமி பார்த்து </span>
        <span class="sans">பூம்யை நம:</span>
        <span class="hint"> நேரே பார்த்து </span>
        <span class="sans">விஷ்ணவே நம: </span>
        <hr class="orange">
        <span class="sans"> प्राच्यै दिशे नम: ।
          <br> दक्षिणस्यै दिशे नम: ।
          <br> प्रतीच्यै दिशे नम: ।
          <br> उदीच्यै दिशे नम: ।
          <br> उूर्ध्वायै नम: ।
          <br> अधरायै नम: ।
          <br> अन्तरिक्षाय नम: ।
          <br> भूम्यै नम: ।
          <br> श्रीविष्णवे नम: ।</span>
        <span class="sans"> த்யேயத்ஸதா ஸவித்ரு மண்டல
          மத்யவர்த்தி நாராயண சரசிஜாஸந: ஸந்நிவிஷ்ட:
          கேயூரவாந் மகர குண்டலவாநு கிரீடி ஹாரி ஹிரண்மயவபு:
          த்ருத சங்கச்சக்ர: சங்கச்சக்ர கதாபாணே
          த்வாரகா நிலையாஸ்ச்யுதா கோவிந்த
          புண்டரீகாக்ஷ ரக்ஷமாம் சரணாகதம்.
          நமோ ப்ரஹ்மண்ய
          தேவாய கோப்ராஹ்மண ஹிதாயச
          ஜகத்ஹிதாய ஸ்ரீக்ருஷ்ணாய கோவிந்தாய நமோ நம:
        <hr class="orange">
          ध्येय: सदा सवितृमण्डल मध्यवर्ती नारायण: सरसिजासन: सिन्नविष्ट: ।
          <br> केयूरवान् मकरकुण्डलवान् किरीटी हारी हिरण्मयवपु: धृतशङ्खचक्र: ।।
          <br> शङ्खचक्रगदापाणे द्वारकानिलयच्युत ।
          <br> गोविन्द पुण्डरीकाक्ष रक्ष मां शरणागतम्।।
          <br> नमो ब्रह्मण्यदेवाय गोब्राह्मणहिताय च ।
          <br> जगद्धिताय कृष्णाय गोविन्दाय नमो नम: ।।
        </span>
        <img src="assets/img/shastanga.JPG" />
        <span class="hint"> என்று வடகலை 4 தரம் - தென்கலை - 1 தரம் - ஸேவிக்கவேண்டும்.
        </span>
        <img src="assets/img/abhivathi.jpg" class="img1" />&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
        <span class="hint">
          அபிவாதனம் பண்ணவேண்டியது.&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
        </span>
      </div>
      </mat-tab>
        <mat-tab label="மதியம்">
          <div class="div3">
            <div class="hint">
              வடக்கே பார்த்து கைகூப்பி </div>
            <div class="prayogam">‘ஓம் ஸந்த்யாயை நம:”</div>
            <div class="hint"> கிழக்கே பார்த்து கைகூப்பி </div>
            <div class="prayogam">‘ஸாவித்ரியை நம:”</div>
            <div class="hint"> தெற்கே பார்த்து கைகூப்பி </div>
            <div class="prayogam">‘ காயத்ரியை நம:”</div>
            <div class="hint"> மேற்கே பார்த்து கைகூப்பி </div>
            <div class="prayogam">‘ஸரஸ்வத்யை நம:”</div>
            <div class="hint"> கிழக்கே கைகூப்பி </div>
            <div class="prayogam">‘ஸர்வாப்யோ தேவதாப்யோ நமோ நம:”</div>
            <div class="sans">
              ओं सन्ध्यायै नम:।
              <br> ओं सावित्र्यै नम: ।
              <br> ओं गायत्र्यै नम: ।
              <br> ओं सरस्वत्यै नम: ।
              <br> सर्वाभ्यो देवताभ्यो नमो नम: ।
  
            </div>
            <div class="hint"> கிழக்குப்பார்த்து சாஷ்டாங்கமாக </div>
            <div class="prayogam">‘காமோகார்ஷீத் மந்யுர கார்ஷீத் நமோ நம:” </div>
            <div class="sans">
              कामोऽकार्षीन्मन्युरकार्षीन् नमो नम: ।
            </div>
            <hr>
            <img src="assets/img/shastanga.JPG" class="img1">
            <div class="hint"> என்று, வடகலை 4 தரம் - தென்கலை - 1 தரம் - ஸேவிக்கவேண்டும்.
            </div>
            <hr>
            <img src="assets/img/abhivathi.jpg" class="img1">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
            <div class="hint">
              அபிவாதனம் பண்ணவேண்டியது.&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
            </div>
  
            <hr>
  
            <div class="hint"> மேற்கே பார்த்து </div>
            <div class="prayogam">‘ப்ரதீச்யை திசே நம:”</div>
            <div class="hint"> வடக்கே பார்த்து </div>
            <div class="prayogam">‘உதீச்யை திசே நம:” </div>
            <div class="hint">கிழக்கே பார்த்து </div>
            <div class="prayogam">‘ஓம் ப்ராச்யை திசே நம:”</div>
            <div class="hint"> தெற்கே பார்த்து </div>
            <div class="prayogam">‘தக்ஷிணாயை திசே நம: “</div>
            <div class="hint">பின் ப்ரதக்ஷிணமாக கிழக்கே திரும்பி
              <br> மேலே பார்த்து </div>
            <div class="prayogam">‘ஊர்த்வாய நம:”</div>
            <div class="hint">கீழே பார்த்து </div>
            <div class="prayogam">‘அதராய நம:”</div>
            <div class="hint"> மேலே பார்த்து </div>
            <div class="prayogam">‘அந்தரிக்ஷாய நம:”</div>
            <div class="hint"> பூமி பார்த்து </div>
            <div class="prayogam"> ‘பூம்யை நம:”</div>
            <div class="hint"> நேரே பார்த்து </div>
            <div class="prayogam"> ‘விஷ்ணவே நம: </div>
            <div class="sans"> प्राच्यै दिशे नम: ।
              <br> दक्षिणस्यै दिशे नम: ।
              <br> प्रतीच्यै दिशे नम: ।
              <br> उदीच्यै दिशे नम: ।
              <br> उूर्ध्वायै नम: ।
              <br> अधरायै नम: ।
              <br> अन्तरिक्षाय नम: ।
              <br> भूम्यै नम: ।
              <br> श्रीविष्णवे नम: ।</div>
            <div class="prayogam"> த்யேயத்ஸதா ஸவித்ரு மண்டல
              மத்யவர்த்தி நாராயண
              சரசிஜாஸந: ஸந்நிவிஷ்ட: கேயூரவாந் மகர குண்டலவாநு
              கிரீடி ஹாரி ஹிரண்மயவபு:
              த்ருத சங்கச்சக்ர: சங்கச்சக்ர கதாபாணே த்வாரகா
              நிலையாஸ்ச்யுதா கோவிந்த புண்டரீகாக்ஷ ரக்ஷமாம்
              சரணாகதம். நமோ ப்ரஹ்மண்ய
              தேவாய கோப்ராஹ்மண ஹிதாயசா ஜகத்ஹிதாய
              ஸ்ரீக்ருஷ்ணாய கோவிந்தாய நமோ நம:”</div>
            <div class="sans">
              ध्येय: सदा सवितृमण्डल मध्यवर्ती नारायण: सरसिजासन: सिन्नविष्ट: ।
              <br> केयूरवान् मकरकुण्डलवान् किरीटी हारी हिरण्मयवपु: धृतशङ्खचक्र: ।।
              <br> शङ्खचक्रगदापाणे द्वारकानिलयच्युत ।
              <br> गोविन्द पुण्डरीकाक्ष रक्ष मां शरणागतम्।।
              <br> नमो ब्रह्मण्यदेवाय गोब्राह्मणहिताय च ।
              <br> जगिद्धताय कृष्णाय गोविन्दाय नमो नम: ।।
            </div>
            <hr>
            <img src="assets/img/shastanga.JPG" class="img1">
            <div class="hint"> என்று வடகலை 4 தரம் - தென்கலை - 1 தரம் - ஸேவிக்கவேண்டும்.
            </div>
            <hr>
            <img src="assets/img/abhivathi.jpg" class="img1">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
            <div class="hint">
              அபிவாதனம் பண்ணவேண்டியது.&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
            </div>
  
            <hr>
          </div>
        </mat-tab>
        <mat-tab label="மாலை">
         <div class="div3">
          <div class="hint">
            கிழக்கே பார்த்து கைகூப்பி </div>
          <div class="prayogam">‘ஓம் ஸந்த்யாயை நம:”</div>
          <div class="hint"> தெற்கு பார்த்து கைகூப்பி </div>
          <div class="prayogam">‘ஸாவித்ரியை நம:”</div>
          <div class="hint"> மேற்கே பார்த்து கைகூப்பி </div>
          <div class="prayogam">‘ காயத்ரியை நம:”</div>
          <div class="hint"> வடக்கே பார்த்து கைகூப்பி </div>
          <div class="prayogam">‘ஸரஸ்வத்யை நம:”</div>
          <div class="hint"> கிழக்கே கைகூப்பி </div>
          <div class="prayogam">‘ஸர்வாப்யோ தேவதாப்யோ நமோ நம:”</div>
          <div class="sans">
            ओं सन्ध्यायै नम:।
            <br> ओं सावित्र्यै नम: ।
            <br> ओं गायत्र्यै नम: ।
            <br> ओं सरस्वत्यै नम: ।
            <br> सर्वाभ्यो देवताभ्यो नमो नम: ।
  
          </div>
          <div class="hint"> கிழக்குப்பார்த்து சாஷ்டாங்கமாக </div>
          <div class="prayogam">‘காமோகார்ஷீத் மந்யுர கார்ஷீத் நமோ நம:” </div>
          <div class="sans">
            कामोऽकार्षीन्मन्युरकार्षीन् नमो नम: ।
          </div>
          <hr>
          <img src="assets/img/shastanga.JPG" class="img1">
          <div class="hint"> என்று, வடகலை 4 தரம் - தென்கலை - 1 தரம் - ஸேவிக்கவேண்டும்.
          </div>
          <hr>
          <img src="assets/img/abhivathi.jpg" class="img1">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
          <div class="hint">
            அபிவாதனம் பண்ணவேண்டியது.&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
          </div>
  
          <hr>
          <div class="hint">கிழக்கே பார்த்து </div>
          <div class="prayogam">‘ஓம் ப்ராச்யை திசே நம:”</div>
          <div class="hint"> தெற்கே பார்த்து </div>
          <div class="prayogam">‘தக்ஷிணாயை திசே நம: “</div>
          <div class="hint"> மேற்கே பார்த்து </div>
          <div class="prayogam">‘ப்ரதீச்யை திசே நம:”</div>
          <div class="hint"> வடக்கே பார்த்து </div>
          <div class="prayogam">‘உதீச்யை திசே நம:” </div>
          <div class="hint">பின் கிழக்கே திரும்பி
            <br> மேலே பார்த்து </div>
          <div class="prayogam">‘ஊர்த்வாய நம:”</div>
          <div class="hint">கீழே பார்த்து </div>
          <div class="prayogam">‘அதராய நம:”</div>
          <div class="hint"> மேலே பார்த்து </div>
          <div class="prayogam">‘அந்தரிக்ஷாய நம:”</div>
          <div class="hint"> பூமி பார்த்து </div>
          <div class="prayogam"> ‘பூம்யை நம:”</div>
          <div class="hint"> நேரே பார்த்து </div>
          <div class="prayogam"> ‘விஷ்ணவே நம: </div>
          <div class="sans"> प्राच्यै दिशे नम: ।
            <br> दक्षिणस्यै दिशे नम: ।
            <br> प्रतीच्यै दिशे नम: ।
            <br> उदीच्यै दिशे नम: ।
            <br> उूर्ध्वायै नम: ।
            <br> अधरायै नम: ।
            <br> अन्तरिक्षाय नम: ।
            <br> भूम्यै नम: ।
            <br> श्रीविष्णवे नम: ।</div>
          <div class="prayogam"> த்யேயத்ஸதா ஸவித்ரு மண்டல
            மத்யவர்த்தி நாராயண சரசிஜாஸந: ஸந்நிவிஷ்ட:
             கேயூரவாந் மகர குண்டலவாநு கிரீடி ஹாரி ஹிரண்மயவபு:
            த்ருத சங்கச்சக்ர: சங்கச்சக்ர கதாபாணே த்வாரகா
             நிலையாஸ்ச்யுதா கோவிந்த புண்டரீகாக்ஷ ரக்ஷமாம் சரணாகதம். நமோ ப்ரஹ்மண்ய
            தேவாய கோப்ராஹ்மண ஹிதாயசா ஜகத்ஹிதாய ஸ்ரீக்ருஷ்ணாய கோவிந்தாய நமோ நம:”</div>
          <div class="sans">
            ध्येय: सदा सवितृमण्डल मध्यवर्ती नारायण: सरसिजासन: सिन्नविष्ट: ।
            <br> केयूरवान् मकरकुण्डलवान् किरीटी हारी हिरण्मयवपु: धृतशङ्खचक्र: ।।
            <br> शङ्खचक्रगदापाणे द्वारकानिलयच्युत ।
            <br> गोविन्द पुण्डरीकाक्ष रक्ष मां शरणागतम्।।
            <br> नमो ब्रह्मण्यदेवाय गोब्राह्मणहिताय च ।
            <br> जगिद्धताय कृष्णाय गोविन्दाय नमो नम: ।।
          </div>
          <hr>
          <img src="assets/img/shastanga.JPG" class="img1">
          <div class="hint"> என்று வடகலை 4 தரம் - தென்கலை - 1 தரம் - ஸேவிக்கவேண்டும்.
          </div>
          <hr>
          <img src="assets/img/abhivathi.jpg" class="img1">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
          <div class="hint">
            அபிவாதனம் பண்ணவேண்டியது.&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
          </div>   
          </div>
        </mat-tab>
      </mat-tab-group></div>
</mat-expansion-panel>
     <mat-expansion-panel>
          <mat-expansion-panel-header>20 - ஸந்தி முடிவு </mat-expansion-panel-header>
          <div class="div3">  <div class="hint">
          ஜபம் பண்ணின இடத்தில் </div>
        <div class="sans">ஓம் பூர்புவஸ்ஸுவ:</div>
        <div class="hint"> என்று ப்ரோக்ஷித்து
          <br> தலைப்பு 1ன் படி இரண்டு தரம் ஆசமனம்.</div>
        <div class="hint">
            <img src="assets/svg/vkThiruman.svg" class="svgs" > வடகலையார் மட்டும்: </div>
        <div class="sans">பகவாநேவ ஸ்வசேஷ பூதமிதம் ப்ராதஸ் 
          / (மதியம்) மாத்யாஹ்நிக /(மாலை) ஸாயம் 
          ஸந்த்யாவந்தநாக்யம் கர்ம ஸ்வஸ்மை ஸவப்ரீதயே பகவாந் ஸ்வயமேவ காரிதவாந்</div>
        <div class="hint"> பாக்கி தீர்த்தத்தை ஏதேனும் செடிக்கடியில்
        </div>
        <div class="sans">காயேந வாசா மநஸே இந்த்ரியைர்வா புத்யா ஆத்மநாவா ப்ரஹ்ருதே: ஸ்வபாவாது கரோமி யத்யது ஸகலம் பரஸ்மை ஸ்ரீமந் நாராயணாயேதி
          ஸமர்ப்பயாமி.” </div>
        <div class="hint"> என்று விட்டுவிடவேண்டியது.</div>
        <div class="sans">ஸர்வம் ஸ்ரீக்ருஷ்ணார்பணமஸ்து - அச்யுத: ப்ரீயதாம்” </div>
        <div class="hint"> காலை - ஸந்தியாவந்தனம் இத்துடன் முடிந்தது.
        </div>
        <img src="assets/img/slide_favorites.jpg" class="img2">
        <div class="hint"> பெருமாள் ஸேவித்து, பெற்றோர் பெரியவாளை தனித்தனி (தம்பதியாகச்) ஸேவித்து அபிவாதி பண்ணவும்.
          <br> குறிப்பு:- ஒரு தம்பதி அல்லது ஒரு ஆண் பெரியவரை மட்டும் ஸேவிக்கும்போது அபிவாதி, ஒன்றுக்கு மேற்பட்டோரை ஒன்றாகச் ஸேவிக்கும்போதும்,
          பெருமாளுக்கும், ஸந்யாஸிகளுக்கும் அபிவாதி கிடையாது.
        </div>
        <hr class="orange">
        <h1 style="font-size:78px; color:white;">* * *</h1>
        <hr class="orange"></div>
      </mat-expansion-panel> 
  </mat-accordion>`;

const PraathasandhiPage = () => {
  return (
    <div className="vaideekam-page-container w-full max-w-4xl mx-auto p-4 md:p-6 pb-24">
      <SEO title="ஸந்தி 3 வேளை - Ahobilam" />
      <div 
        className="vaideekam-content bg-white p-6 rounded-xl shadow-sm border border-green-100/50"
        dangerouslySetInnerHTML={{ __html: HTML_CONTENT }} 
      />
    </div>
  );
};

export default PraathasandhiPage;
